
// @ts-ignore
import anime from 'animejs';

import { get, getAll, isBreakpoint } from '../../helpers/utilities';

export class MainMenu {
    private container: Element;
    private menuItems: Element[];


    /**
     * Initialises a new instance of MainMenu
     * 
     * @param container The root element for this component.
     */
    constructor(container: Element) {
        this.container = container;
        this.menuItems = getAll('.js-main-menu__item', container) as Element[];
        this.bindEvents();
    }


    /**
     * Bind the events for this component.
     */
    private bindEvents(): void {

        // Dropdown button click
        const dropdownBtns = getAll('.js-main-menu__button', this.container);
        if(dropdownBtns) {
            dropdownBtns.forEach(btn => {
                btn.addEventListener('click', () => {
                    const parent = btn.parentNode as Element;
                    if(parent) this.toggleDropdown(parent);
                });
            });
        }

        // Open on hover, close on hover off
        let openTimer: any;
        this.menuItems.forEach(item => {

            // @ts-ignore
            item.closeTimer = 0;

            item.addEventListener('mouseover', () => {
                // @ts-ignore
                clearTimeout(item.closeTimer);
                clearTimeout(openTimer);
                openTimer = setTimeout(() => {
                    this.openDropdown(item);
                }, 200);
            });

            item.addEventListener('mouseleave', () => {
                // @ts-ignore
                item.closeTimer = setTimeout(() => {
                    this.closeDropdown(item);
                }, isBreakpoint('tablet') ? 0 : 300);
            });
        });
    }


    /**
     * Toggle the dropdown visibility
     * 
     * @param listItem 
     */
    private toggleDropdown(listItem: Element): void {
        this.menuItems.forEach(item => {
            if(item === listItem) {
                if(listItem.classList.contains('c-main-menu__item--is-open')) {
                    this.closeDropdown(listItem);
                } else {
                    this.openDropdown(listItem);
                }
            } else {
                this.closeDropdown(item);
            }
        });
    }


    /**
     * Opens a dropdown
     * 
     * @param listItem The list item to open
     */
    private openDropdown(listItem: Element): void {
        const dropdown = get('.js-main-menu__dropdown', listItem) as HTMLElement;
        const content  = get('.js-main-menu__sub-menu', listItem) as HTMLElement;

        if(dropdown && content) {
            const contentHeight = content.offsetHeight;
            listItem.classList.add('c-main-menu__item--is-open');
            
            if(isBreakpoint('tablet')) {
                anime({
                    targets: dropdown,
                    easing: 'easeInOutCirc',
                    duration: 600,
                    height: `${contentHeight}px`,
                    complete: () => {

                        // Remove the fixed height and add a class to keep it open
                        dropdown.style.height = '';
                        dropdown.classList.add('c-main-menu__dropdown--is-open');
                    }
                });
            }
        }
    }


    /**
     * Closes a dropdown
     * 
     * @param listItem The list item to clsoe
     */
    private closeDropdown(listItem: Element): void {
        const dropdown = get('.js-main-menu__dropdown', listItem) as HTMLElement;
        const content  = get('.js-main-menu__sub-menu', listItem) as HTMLElement;
 
        if(dropdown && content) {
            listItem.classList.remove('c-main-menu__item--is-open');

            if(isBreakpoint('tablet')) {
                anime({
                    targets: dropdown,
                    easing: 'easeInOutCirc',
                    duration: 600,
                    height: 0,
                    complete: () => {

                        // Remove the fixed height and add a class to keep it open
                        dropdown.style.height = '';
                        dropdown.classList.remove('c-main-menu__dropdown--is-open');
                    }
                });
            }
        }
        
    }
}
